import { useEffect, useState }  from "react";
import ApiModels from '../../api/models';
import { useSelector, useDispatch } from "react-redux";
import { BiCheckbox, BiCheckboxChecked, BiCheckboxSquare } from "react-icons/bi";

import { log as actionsLog } from '../../store/actions';

const { addToLog } = actionsLog;

const Bodytypes = () => {

    let dispatch = useDispatch();

    let selectedModel = useSelector(store => store.models.selectedModel);

    const [ trigger, setTrigger ] = useState(0);
    const [ canSave, setCanSave ] = useState(false);
    const [ bodytypes, setBodytypes ] = useState([]);
    const [ bodytypesByModel, setBodytypesByModel ] = useState({});
    const [ selectedIds, setSelectedIds] = useState('');

    useEffect(() => {
        ApiModels.getBodytypes().then(json => {
            setBodytypes(json.bodytypes);
        });
    }, [trigger]);

    useEffect(() => {
        ApiModels.getBodytypesForModel(selectedModel.id).then(json => {
            let obj = {};
            json.bodytypes.forEach(bt => {
                obj[bt.id] = bt;
            })
            setBodytypesByModel(obj);
            setSelectedIds(createIDs(json.bodytypes.map(item => item.id)));
            setCanSave(false);
        });
    }, [selectedModel]);

    const createIDs = arr => {
        return arr.reduce((temp, aggr) => `${temp}${temp ? ',' : ''}${aggr}`, '');
    }

    const onBodytypeClick = bt => {
        let newBodytypesByModel = {
            ...bodytypesByModel,
            [bt.id]: bodytypesByModel[bt.id] ? null : bt
        };
        const userSelected = createIDs(Object.keys(newBodytypesByModel).filter(item => newBodytypesByModel[item]));
        setCanSave(selectedIds != userSelected);
        setBodytypesByModel(newBodytypesByModel);
    };

    const save = () => {
        const userSelected = Object.keys(bodytypesByModel).filter(item => bodytypesByModel[item]);
        const preselected = selectedIds.split(",");

        let bodytypesToInsert = userSelected.filter(x => !preselected.includes(x)).map(x => Number(x));
        let bodytypesToDelete = preselected.filter(x => !userSelected.includes(x)).map(x => Number(x));

        let proceed = window.confirm(`Update bodytypes for model: ${selectedModel.name}?`);
        if (proceed) {
            ApiModels.setBodytypesForModel(selectedModel.id, bodytypesToInsert, bodytypesToDelete).then(resp => {
                setTrigger(new Date());
                setCanSave(false);
                dispatch(addToLog(resp));
            });
        }
    }

    const buttonClass = (additional) => {
        return `${additional} border rounded ${canSave ? 'border-blue-700 bg-blue-800 cursor-pointer hover:bg-blue-700 hover:border-blue-800 text-white' : 'border-gray-700 bg-gray-800 cursor-not-allowed'}`;
    }

    return (
        <div>
            {
                selectedModel?.id > 0 ? 
                <div className="border border-gray-700 mb-2">
                <div className="text-lg p-2 bg-gray-900">
                    Bodytypes { selectedModel.id > -1 ? "for " + selectedModel.name : "" }
                </div>
                <div className="flex flex-1 flex-wrap">
                    {
                        bodytypes.map(bt => {
                            return (
                                <div key={bt.id} className="w-1/3 cursor-pointer hover:bg-gray-700 flex p-1" onClick={() => onBodytypeClick(bt)}>
                                    {
                                        bodytypesByModel[bt.id] ?
                                        <BiCheckboxChecked className="flex-shrink-0 text-2xl text-blue-400" />
                                        :
                                        <BiCheckbox className="flex-shrink-0 text-2xl" />
                                    }
                                    { bt.name }
                                </div>
                            )
                        })
                    }
                </div>
                <div className="p-2 flex">
                    <button className={buttonClass('ml-auto p-2')} disabled={!canSave} onClick={save}>Save</button>
                </div>
            </div>
            : 
            <></>
            }
            
        </div>
    );
}

export default Bodytypes;